import {
  getRankAndViewService,
  getPlaceandTargetService,
  getTradeService,
  getDigest
} from '@/service/getData'
import {
  getUserInfoService, //获取登录信息
} from '@/service/login';
import common from "@/config/common";
import {
  GET_PLACES,
  GET_TARTYPE,
  GET_ALLOT,
  GET_GBHY,
  GET_USERINFO,
  GET_TRADE,
  GET_TARGET,
  DEL_USERINFO,
  GET_USER_DIGEST
} from './mutation-types'

export default {
  async getUserInfoAction({
    commit,
    state
  }) {
    let {
      userInfo
    } = state;
    if (userInfo.id) {
      return;
    }
    let rsp = await getUserInfoService();
    if (rsp.data && rsp.data.ok && !rsp.data.err && rsp.data) {
      let info = rsp.data.info || {};
      commit(GET_USERINFO, info);
    }
  },
  delUserInfoAction({ commit, state }) {
    commit(DEL_USERINFO, {});
  },
  //获取领域
  getTradeAction({
    commit,
    state
  }) {

    //如果place有值返回
    if (state.tradeObj.trade.length > 0) {
      return;
    }

    getTradeService().then((rsp) => {
      if (rsp.data && rsp.data.ok && !rsp.data.err) {
        let trade = rsp.data.enum.trade || [];
        let trade_sub = rsp.data.enum.trade_sub || [];
        trade_sub = common.getSubDict(trade_sub);
        let tradeObj = {
          trade,
          trade_sub,
        };
        commit(GET_TRADE, tradeObj);
      }
    });
  },
  //获取城市和需求类型
  getPlaceandTargetAction({
    commit,
    state
  }) {

    //如果place有值返回 targetArr不为空  allotArr不为空
    if (state.placeObj.place.length > 0 && state.targetArr.length > 0 && state.allotArr.length > 0 && state.gbhyArr.length > 0) {
      return;
    }

    getPlaceandTargetService().then((rsp) => {
      if (rsp.data && rsp.data.ok && !rsp.data.err) {
        //处理城市数据
        var place = rsp.data.enum.place || [];
        var place_sub = rsp.data.enum.place_sub || [];
        place_sub = common.getSubDict(place_sub);
        var placeObj = {
          place,
          place_sub,
        };
        commit(GET_PLACES, placeObj);
        var gb_hy = rsp.data.enum.gb_hy || [];
        var cooperation_type = rsp.data.enum.cooperation_type || [];
        var targetObj = {
          gb_hy,
          cooperation_type,
        };
        commit(GET_TARGET, targetObj);
        //处理需求类型数据
        // var targetArr = rsp.data.enum.type || [];
        // commit(GET_TARTYPE, targetArr);

        // var allotArr = rsp.data.enum.allot || [];
        // commit(GET_ALLOT, allotArr);

        // var gbhyArr = rsp.data.enum.gb_hy || [];
        // commit(GET_GBHY, gbhyArr);
      }
    });
  },
    async getUserDigest({ commit, state }, ifMine = true){
    let {userDigest} = state;
    if (Object.keys(userDigest).length && ifMine) {
      return;
    }
    let rsp = await getDigest();
    if (rsp.data && rsp.data.ok && !rsp.data.err && rsp.data) {
      let info = rsp.data.info || {};
      commit(GET_USER_DIGEST, info);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/action.js